// removed by extract-text-webpack-plugin
module.exports = {"trust":"trust___1lSSP","centered":"centered___8v4dh","images":"images___1nV85","column-title":"column-title___3OYcy","shop":"shop___2TPZU","column-content":"column-content___PzxaA","column-content-left":"column-content-left___HNA-Y","column-content-right":"column-content-right___2EKg8","separator":"separator___1NVdZ"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Footer/Trust/Trust.scss
// module id = 1bC0
// module chunks = 46